import './warehouses';
import './warehouses-list';
import './warehouses-edit';